import Router from './index.vue';

export default [
  {
    path: '/router',
    name: 'Router',
    component: Router,
    meta: {
      title: '路由结构'
    }
  },
];



// WEBPACK FOOTER //
// ./src/views/Router/index.js